export default defineNuxtRouteMiddleware((to) => {
    const { isAuthenticated, isInternalUser, login, logout, user } = useUser();
    const { hasAccessToPath } = userConditions(user?.value);

    if (to.path.startsWith('/.well-known')) {
        return;
    }

    // console.log('===========================');
    // console.log(to.path);

    if (import.meta.client && to.meta.isAuthRequired === false) {
        $fetch(
            `${useRuntimeConfig().public.businessPortal.url}/int/session/auth`,
            {
                credentials: 'include',
            },
        ).then((response) => {
            if (response?.data?.sso && !isAuthenticated.value) {
                // auto-login
                return login({
                    provider: 'oauth',
                    redirectUrl: to.path,
                });
            }
        });
    }

    if (
        isInternalUser.value
        && !to.path.startsWith('/p/internal')
        && !to.path.startsWith('/api')
        && !to.path.startsWith('/debug')
    ) {
        // Internal user spotted outside of internal area!
        // Brutal: kill their session to make sure they can navigate the B2B areas without issues
        // TODO as soon as Keycloak is in place for all realms this should degrade more gracefully
        // console.log('logging out internal user');
        return logout({
            provider: 'oauth-internal',
            redirectUrl: to.path,
        });
    }

    if (to.path.startsWith('/p/internal') && !to.path.startsWith('/p/internal/login')) {
        if (isAuthenticated.value && isInternalUser.value && hasAccessToPath(to.path)) {
            return;
        }

        return navigateTo('/p/internal/login');
    }

    if (isAuthenticated.value) {
        // console.log('already athenticated');
        return;
    }

    if (to.meta.isAuthRequired === false) {
        // console.log('public page');
        return;
    }

    return login({ provider: 'oauth', redirectUrl: to.path });
});
